import { EbDemande } from "./demande";
import { EbEtablissement } from "./etablissement";
import { EbCompagnie } from "./compagnie";
import { EbParty } from "./party";
import { Statique } from "../utils/statique";

export class EbExpedition {
  ebExpeditionNum: number;

  // INFORMATION ENTETE
  dateCreationExpedition: Date;
  xEbEtablissement: EbEtablissement;
  xEbCompagnie: EbCompagnie;
  xEcStatut: number;
  expeditionReference: String;


  // INFORMATION EXPEDITION

  commandeNum: String;

  dateDispo: Date;
  ebPartyOrigin: EbParty;
  ebPartyDest: EbParty;

  insurance: Boolean;
  insuranceValue: number;
  villeInco: String;
  dateOfArrival: Date;
  xEcModeTransport: number;
  commentaire: String;
  //------ INFORMATIOn TRANSPORT

  nAwbBol: String;
  flightVessel: String;
  datePrevuRamassage: Date;
  heurePrevuRamassage: String;
  etaDate: Date;
  EtaHeure: String;
  etdDate: Date;
  EtdHeure: String;
  dateLivraison: Date;
  heureLivraison: String;
  mawb: String;
  xEcIncoterm: number;
  customsOffice: String;

  listDemandes: Array<EbDemande> = new Array<EbDemande>();

  nbrTotalUntits: number;
  totalWeight: number;
  totalVolume: number;
  totalTaxableWeight: number;
  dateStatut: Date;
  numBL : string;
  numTC : string;

  constructor(){
    this.ebExpeditionNum = null;
    this.dateCreationExpedition = null;
    this.xEbEtablissement = null;
    this.xEbCompagnie = null;
    this.xEcStatut = null;
    this.expeditionReference = null;
    this.dateDispo = null;
    this.ebPartyOrigin = null;
    this.ebPartyDest = null;
    this.insurance = null;
    this.insuranceValue = null;
    this.nAwbBol = null;
    this.datePrevuRamassage = null;
    this.heurePrevuRamassage = null;
    this.etaDate = null;
    this.EtaHeure = null;
    this.dateLivraison = null;
    this.heureLivraison = null;
    this.mawb = null;
    this.xEcIncoterm = null;
    this.listDemandes = null;
    this.nbrTotalUntits = null;
    this.totalWeight = null;
    this.totalVolume = null;
    this.totalTaxableWeight = null;
    this.commandeNum = null;
    this.dateOfArrival = null;
    this.xEcModeTransport = null;
    this.villeInco = null;
    this.commentaire = null;
    this.etdDate = null;
    this.EtdHeure = null;
    this.flightVessel = null;
    this.customsOffice = null;
    this.dateStatut = null;
    this.numBL = null;
    this.numTC = null;
  }

  clone() {
    return JSON.parse(JSON.stringify(this))
  }

  cloneData(data: EbExpedition){
    this.ebExpeditionNum = data.ebExpeditionNum;
    this.dateCreationExpedition = data.dateCreationExpedition;
    this.xEbEtablissement = data.xEbEtablissement;
    this.xEbCompagnie = data.xEbCompagnie;
    this.xEcStatut = data.xEcStatut;
    this.expeditionReference = data.expeditionReference;
    this.dateDispo = data.dateDispo;
    this.ebPartyOrigin = data.ebPartyOrigin;
    this.ebPartyDest = data.ebPartyDest;
    this.insurance = data.insurance;
    this.insuranceValue = data.insuranceValue;
    this.nAwbBol = data.nAwbBol;
    this.datePrevuRamassage = Statique.convertToUTC(data.datePrevuRamassage);
    this.heurePrevuRamassage = data.heurePrevuRamassage;
    this.etaDate = Statique.convertToUTC(data.etaDate);
    this.EtaHeure = data.EtaHeure;
    this.dateLivraison = Statique.convertToUTC(data.dateLivraison);
    this.heureLivraison = data.heureLivraison;
    this.mawb = data.mawb;
    this.numBL = data.numBL;
    this.numTC = data.numTC;
    this.xEcIncoterm = data.xEcIncoterm;
    this.listDemandes = data.listDemandes;
    this.nbrTotalUntits = data.nbrTotalUntits;
    this.totalWeight = data.totalWeight;
    this.totalVolume = data.totalVolume;
    this.totalTaxableWeight = data.totalTaxableWeight;
    this.commandeNum = data.commandeNum;
    this.dateOfArrival = data.dateOfArrival;
    this.xEcModeTransport = data.xEcModeTransport;
    this.villeInco = data.villeInco;
    this.commentaire = data.commentaire;
    this.etdDate = Statique.convertToUTC(data.etdDate);
    this.EtdHeure = data.EtdHeure;
    this.flightVessel = data.flightVessel;
    this.customsOffice = data.customsOffice;
    this.dateStatut = data.dateStatut;
  }

}



// WEBPACK FOOTER //
// ./src/app/classes/expedition.ts